<template>
  <div id="environmentPage">
    <nav class="screenBox">
      <div class="infoType">
        <div
          :class="{infoTypeItem: true, infoTypeSelItem: item.isSelected}"
          v-for="(item, index) in infoTypeDatas"
          :key="index"
          @click="infoTypeScreenTapAction(index)"
        >{{item.name}}</div>
      </div>
      <div>
        <el-image
          class="screenDateItem"
          v-for="(img, index) in screenDateImgs"
          :key="index"
          :src="img.url"
          @click="screenDatetapAction(index)"
        ></el-image>
      </div>
    </nav>
    <div class="sectionItem" v-for="(sectionItem, index) in dataSource" :key="index">
      <div class="sectionTitle">
        <span class="bigCls"></span>
        <span class="smallCls"></span>
        {{sectionItem.name}}
      </div>
      <div class="sectionContent">
        <div class="chartBox" v-for="(item, itemIndex) in sectionItem.equipments" :key="itemIndex">
          <lineChartComponent :dataSource="item" :dateType="screenDateImgs[curSelectedIndex].dateValue" :energyType="infoTypeDatas[curSelectedInfoIndex].infoType"></lineChartComponent>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateType, energySystemType, energyDataType } from "@/utils/typeParam";
import lineChartComponent from "@/components/subComponents/lineChartComponent";
import requestObjc from "@/utils/requestObjc";
import mainStore from '@/store/storeMain';
import { mapGetters } from 'vuex';

export default {
  name: "environment",
  store: mainStore,
  components: {
    lineChartComponent
  },
  data() {
    return {
      curSelectedIndex: 0,
      screenDateImgs: [
        {
          url: require("@/assets/hour_blue.png"),
          imgUrl: require("@/assets/hour.png"),
          imgSelUrl: require("@/assets/hour_blue.png"),
          dateValue: dateType.hourType
        },
        {  
          url: require("@/assets/day.png"),
          imgUrl: require("@/assets/day.png"),
          imgSelUrl: require("@/assets/day_blue.png"),
          dateValue: dateType.dayType
        },
        {
          url: require("@/assets/month.png"),
          imgUrl: require("@/assets/month.png"),
          imgSelUrl: require("@/assets/month_blue.png"),
          dateValue: dateType.monthType
        }
      ],
      curSelectedInfoIndex: 0,
      infoTypeDatas: [
        {
          name: "温度",
          infoType: energyDataType.temperature,
          isSelected: true
        },
        {
          name: "湿度",
          infoType: energyDataType.humidity,
          isSelected: false
        },
        {
          name: "甲醛",
          infoType: energyDataType.formaldehyde,
          isSelected: false
        },
        {
          name: "CO2",
          infoType: energyDataType.co2,
          isSelected: false
        }
      ],
      dataSource: [] //数据源
    };
  },
  computed: {
    ...mapGetters({
      curHouseInfo: 'getCurHouseInfo'
    })
  },
  created() {
    this.requestData(energyDataType.temperature, 1);
  },
  methods: {
    //选择时间
    screenDatetapAction(tapIndex) {
      if (this.curSelectedIndex == tapIndex) {
        return;
      }
      this.screenDateImgs[this.curSelectedIndex].url = this.screenDateImgs[
        this.curSelectedIndex
      ].imgUrl;
      this.screenDateImgs[tapIndex].url = this.screenDateImgs[
        tapIndex
      ].imgSelUrl;
      this.curSelectedIndex = tapIndex;
      this.$set(this, "dataSource", []);
      this.requestData(
        this.infoTypeDatas[this.curSelectedInfoIndex].infoType,
        this.screenDateImgs[tapIndex].dateValue
      );
    },
    //选择环境类型
    infoTypeScreenTapAction(tapIndex) {
      if (this.curSelectedInfoIndex == tapIndex) {
        return;
      }
      this.infoTypeDatas[this.curSelectedInfoIndex].isSelected = false;
      this.infoTypeDatas[tapIndex].isSelected = true;
      this.curSelectedInfoIndex = tapIndex;
      this.$set(this, "dataSource", []);
      this.requestData(
        this.infoTypeDatas[tapIndex].infoType,
        this.screenDateImgs[this.curSelectedIndex].dateValue
      );
    },
    //请求数据
    requestData(infoType, dateType) {
      var params = {
        dataType: infoType,
        datatimetype: dateType
      };
      requestObjc
        .requestEnvHistoryData(params, this.curHouseInfo.gatewayId)
        .then(res => {
          var data = JSON.parse(JSON.stringify(res.data));
          data.forEach(floorItem => {
            var floorData = {
              name: floorItem.name,
              equipments: []
            };
            floorItem.rooms.forEach(roomItem => {
              var equipment = {
                title: roomItem.name,
                timeArr: [],
                dataArr: {
                  data1: [],
                  data2: []
                }
              };
              if (roomItem.data != null) {
                roomItem.data.forEach(dataItem => {
                  equipment.timeArr.push(dataItem.key);
                  equipment.dataArr.data1.push(dataItem.data1);
                  equipment.dataArr.data2.push(dataItem.data2);
                });
              }
              floorData.equipments.push(equipment);
            });
            this.dataSource.push(floorData);
          });
        })
        .catch(error => {
          console.log("请求环境数据错误：" + error.message);
        });
    }
  }
};
</script>
<style scoped>
#environmentPage {
  width: 85%;
  margin: 0 auto;
}
.screenBox {
  width: 100%;
  height: 50px;
  margin-top: 30px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.screenDateItem {
  width: 37px;
  height: 37px;
  margin-left: 29px;
}
.screenDateItem:hover {
  cursor: pointer;
}
.infoType {
  min-width: 50%;
}
.infoTypeItem {
  display: inline-block;
  padding: 5px 10px;
  color: #888888;
  margin-right: 30px;
  font-size: 22px;
}
.infoTypeItem:hover {
  cursor: pointer;
}
.infoTypeSelItem {
  background-color: #e1edff;
  border-radius: 2px;
  color: #2592fa;
}
.sectionItem {
  width: 100%;
  background-color: #FFFFFF;
  box-shadow: 0px 8px 18px 0px rgba(206,231,255,0.21);
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.sectionTitle {
  height: 50px;
  font-size: 26px;
  padding-left: 20px;
  display: flex;
  align-items: center;
}
.sectionContent {
  margin: 0px 0px 20px 0px;
  padding: 0px;
  width: 100%;
  display: grid;
  justify-content: space-around;
  grid-template-columns: 600px 600px;
}
@media screen and (max-width: 1600px) {
  .sectionContent {
    grid-template-columns: 500px 500px;
  }
}
.bigCls {
  width: 12px;
  height: 12px;
  background-color: #2592fa;
  border-radius: 50%;
  margin-right: 10px;
}
.smallCls {
  width: 7px;
  height: 7px;
  background-color: #2592fa;
  border-radius: 50%;
  margin-right: 20px;
}
.chartBox {
  height: 260px;
  margin-top: 20px;
  padding-bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/environmentPage.vue